// /home/MOS/.../frontend/src/pages/RegisterPage.jsx
// VERSÃO 10.0 PLATINUM - RECRUTAMENTO ELITE COM QUARENTENA

import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import apiClient from '../api/apiClient';

const MIN_PASSWORD_LENGTH = 8;

export default function RegisterPage() {
  const [formData, setFormData] = useState({
    name: '', // 🎖️ Nome de Guerra (Obrigatório)
    username: '',
    password: '',
    confirmPassword: '',
    companyName: '',
  });
  
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // 🛡️ Validação de Integridade de Dados
    if (!formData.name || !formData.username || !formData.password || !formData.companyName) {
      setError('Todos os campos são obrigatórios para o alistamento.');
      return;
    }
    if (formData.password !== formData.confirmPassword) {
      setError('As chaves de acesso não coincidem.');
      return;
    }
    if (formData.password.length < MIN_PASSWORD_LENGTH) {
      setError(`A chave deve ter no mínimo ${MIN_PASSWORD_LENGTH} caracteres.`);
      return;
    }

    setIsLoading(true);

    try {
      const payload = {
        name: formData.name.trim(),
        username: formData.username.trim().toLowerCase(),
        password: formData.password,
        companyName: formData.companyName.trim(),
      };

      const response = await apiClient.post('/auth/register', payload);
      
      // Feedback de Quarentena
      setSuccess(response.data.message || 'Registro em análise! Redirecionando...');
      
      // Delay para leitura da mensagem de quarentena
      setTimeout(() => navigate('/login'), 4000);

    } catch (err) {
      // Captura a mensagem real do servidor (Erro 400 ou 500)
      const msg = err.response?.data?.message || err.message || 'Falha no protocolo de registro.';
      setError(msg);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 transition-all duration-500"
         style={{ backgroundColor: 'var(--bg-main)' }}>
      
      {/* 🛡️ CARD DE REGISTRO ELITE (GLASS DESIGN) */}
      <div className="w-full max-w-lg p-10 space-y-8 backdrop-blur-xl border rounded-[2.5rem] shadow-[0_50px_100px_rgba(0,0,0,0.3)] transition-all duration-500"
           style={{ backgroundColor: 'var(--bg-card)', borderColor: 'var(--border-color)' }}>
        
        <div className="flex justify-center">
          <img src="/logo.png" alt="MOS" className="w-24 h-24 rounded-full border-2 transition-all duration-500 shadow-2xl" 
               style={{ borderColor: 'var(--border-color)' }} />
        </div>

        <div className="text-center space-y-2">
          <h1 className="text-4xl font-black tracking-tighter uppercase"
              style={{ color: 'var(--text-primary)' }}>
            MOS <span style={{ color: 'var(--accent-color)' }}>Elite</span>
          </h1>
          <p className="text-[10px] font-black uppercase tracking-[0.4em] opacity-40"
             style={{ color: 'var(--text-primary)' }}>
            Protocolo de Nova Identidade
          </p>
        </div>
        
        <form onSubmit={handleRegister} className="grid grid-cols-1 gap-5">
          
          {/* CAMPO: NOME DE GUERRA (NAME) */}
          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest opacity-50 ml-2"
                   style={{ color: 'var(--text-primary)' }}>Nome de Guerra</label>
            <input 
              type="text" name="name" value={formData.name} onChange={handleChange} 
              className="w-full px-5 py-3.5 rounded-2xl outline-none border transition-all"
              style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
              placeholder="Ex: Major Camila" required disabled={isLoading || success} 
            />
          </div>

          {/* CAMPO: IDENTIFICADOR (E-MAIL) */}
          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest opacity-50 ml-2"
                   style={{ color: 'var(--text-primary)' }}>E-mail Institucional</label>
            <input 
              type="email" name="username" value={formData.username} onChange={handleChange} 
              className="w-full px-5 py-3.5 rounded-2xl outline-none border transition-all"
              style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
              placeholder="seu.email@provedor.com" required disabled={isLoading || success} 
            />
          </div>

          {/* GRID DE SENHAS */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest opacity-50 ml-2"
                     style={{ color: 'var(--text-primary)' }}>Nova Senha</label>
              <input 
                type="password" name="password" value={formData.password} onChange={handleChange} 
                className="w-full px-5 py-3.5 rounded-2xl outline-none border transition-all"
                style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
                placeholder="••••••••" required disabled={isLoading || success} 
              />
            </div>
            <div className="space-y-1">
              <label className="text-[10px] font-black uppercase tracking-widest opacity-50 ml-2"
                     style={{ color: 'var(--text-primary)' }}>Confirmar Chave</label>
              <input 
                type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} 
                className="w-full px-5 py-3.5 rounded-2xl outline-none border transition-all"
                style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
                placeholder="••••••••" required disabled={isLoading || success} 
              />
            </div>
          </div>

          {/* CAMPO: EMPRESA */}
          <div className="space-y-1">
            <label className="text-[10px] font-black uppercase tracking-widest opacity-50 ml-2"
                   style={{ color: 'var(--text-primary)' }}>Nome da Organização</label>
            <input 
              type="text" name="companyName" value={formData.companyName} onChange={handleChange} 
              className="w-full px-5 py-3.5 rounded-2xl outline-none border transition-all"
              style={{ backgroundColor: 'var(--bg-main)', borderColor: 'var(--border-color)', color: 'var(--text-primary)' }}
              placeholder="Ex: CAMIS Tecnologias" required disabled={isLoading || success} 
            />
          </div>

          {/* FEEDBACKS (GLASS STYLE) */}
          {error && <div className="bg-red-500/10 border border-red-500/50 text-red-500 text-[10px] font-black uppercase p-3 rounded-xl text-center animate-shake">{error}</div>}
          {success && <div className="bg-cyan-500/10 border border-cyan-500/50 text-[var(--accent-color)] text-[10px] font-black uppercase p-3 rounded-xl text-center">{success}</div>}

          {/* BOTÃO DE REGISTRO */}
          <button 
            type="submit" 
            disabled={isLoading || success} 
            className="w-full py-5 mt-4 font-black uppercase tracking-[0.3em] text-[11px] text-white rounded-2xl transition-all shadow-xl hover:brightness-110 active:scale-95 disabled:opacity-50 flex items-center justify-center gap-3"
            style={{ backgroundColor: 'var(--accent-color)' }}
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            ) : 'Validar Alistamento'}
          </button>
        </form>

        <div className="text-center pt-6 border-t" style={{ borderColor: 'var(--border-color)' }}>
          <Link to="/login" 
                className="text-[10px] font-black uppercase tracking-widest opacity-40 hover:opacity-100 transition-all"
                style={{ color: 'var(--text-primary)' }}>
            Já possui credenciais? <span style={{ color: 'var(--accent-color)' }}>Fazer Login</span>
          </Link>
        </div>
      </div>

      <footer className="text-[8px] font-bold uppercase tracking-[0.5em] opacity-20 mt-10"
              style={{ color: 'var(--text-primary)' }}>
        © 2026 MOS ELITE. OPERAÇÃO RESTRITA.
      </footer>
    </div>
  );
}